import type React from 'react';

const RedesignCorporatePageContent: React.FC = () => null;

export default RedesignCorporatePageContent;
